import { mapActions, mapGetters } from 'vuex'

export default {
  data () {
    return {
      cancelButton: null,
      confirmButton: null,
      hideCancel: null,
      messages: [],
      title: null,
      form: null,
      formModel: null,
      width: null
    }
  },

  watch: {
    userConfirm (userConfirm) {
      const data = userConfirm && userConfirm.data

      this.cancelButton = userConfirm && this.$t(userConfirm.cancel, data)
      this.confirmButton = userConfirm && this.$t(userConfirm.confirm, data)
      this.hideCancel = userConfirm && userConfirm.hideCancel
      this.title = userConfirm && this.$t(userConfirm.title, data)
      this.form = userConfirm && userConfirm.form
      this.formModel = this.form && userConfirm.data
      this.width = userConfirm && userConfirm.width

      let mm = (userConfirm && userConfirm.messages) || []
      if (!Array.isArray(mm)) {
        mm = [mm]
      }

      this.messages = mm.map(m => this.$t(m, data))
    }
  },

  computed: {
    ...mapGetters({
      'userConfirm': 'notificationStore/userConfirm'
    }),
    dialogWidth () {
      return this.width ? this.width : 400
    }
  },

  methods: {
    ...mapActions({
      'removeUserConfirm': 'notificationStore/removeUserConfirm'
    }),

    onCancel () {
      this.userConfirm.onCancel()
      this.removeUserConfirm()
    },

    onConfirm () {
      if (this.form) {
        this.userConfirm.onConfirm(this.formModel)
      } else {
        this.userConfirm.onConfirm()
      }

      this.removeUserConfirm()
    }
  }
}
